'use strict'

import Input from "../../../utils/Input";
import Auth from "../../../libs/API/Auth";
import Alert from "../../../components/Alert";

class ForgotPassword {
  constructor() {
    this.main = document.getElementById('forgot_password');

    this._containerForm = this.main.querySelector('.container_form');
    this._containerSuccess = this.main.querySelector('.container_success');

    this._form = this.main.querySelector('.form');
    this._submit = this.main.querySelector('.btn_send');
    
    this._inputEmail = new Input(this.main.querySelector('input[name="email"]'));

    this._userEmail = this.main.querySelector('.user_email');

    this._sending = false;

    this._form.addEventListener('submit', this._onSubmit.bind(this));
  }

  _onSubmit(e) {
    e.preventDefault();

    if (this._sending) {
      return false;
    }
    
    if (!this._validateForm()) {
      return false;
    }
    
    this._submitData();
    
    return true;
  }
  
  _validateForm() {
    let formOk = true;
    
    if(this._inputEmail.isEmpty) {
      formOk = false;
      this._inputEmail.errorMessage = '*Required field'
      this._inputEmail.error = true;
    } else if(!this._inputEmail.isValidEmail) {
      formOk = false;
      this._inputEmail.errorMessage = '*Wrong email format';
      this._inputEmail.error = true;
    } else {
      this._inputEmail.error = false;
    }
    
    return formOk;
  }
  
  _submitData(){
    
    this._sending = true;
    this._submit.classList.add('button--loading');
    
    Auth.forgotPassword(this._inputEmail.value)
    .then(()=>{
      // Update email
      this._userEmail.innerHTML = this._inputEmail.value;

      // Show success
      this._containerForm.style.display = 'none';
      this._containerSuccess.style.display = 'block';

      this._resetFields();
    })
    .catch(data => {
      switch(data.errorType){
        case 'USER_NOT_FOUND':
          this._inputEmail.reset();
          
          this._inputEmail.errorMessage = 'The email you entered is incorrect'
          this._inputEmail.error = true;
        break;
        case 'EMAIL_SEND_ERROR':
          Alert.show('warning', 'Something went wrong, please try again later.', null, 'Ok');
        break;
      }
   
    })   
   .finally(()=>{
    this._sending = false;
    this._submit.classList.remove('button--loading');
   })
  }

  _resetFields(){
    this._inputEmail.reset();
  }
}

export default ForgotPassword;